export enum ExternalContentProviders {
  MsGraph = "MsGraph",
  PinkwebDossier = "PinkwebDossier",
  Afas = "Afas",
  Hyarchis = "Hyarchis"
}

export enum ExternalContentProviderSource {
  OneDrive = "OneDrive",
  SharePoint = "SharePoint",
  Teams = "Teams",
  Hyarchis = "Hyarchis"
}
